/* Read the shipping test's assignment. Never create a second random split. */
(() => {
  const experimentId = '017c9152-e1bc-4350-bab8-daefbf8f559a';
  const treatmentId = '5f6a43ef-e63d-48c9-b582-0c399ad6f9e0';
  const originals = new WeakMap();
  let treatment = false;

  function render(root = document) {
    root.querySelectorAll('[data-shipping-copy]').forEach((element) => {
      if (!originals.has(element)) originals.set(element, element.innerHTML);
      if (treatment) {
        const message = element.getAttribute('data-shipping-treatment');
        if (message !== null && element.textContent !== message) element.textContent = message;
      } else if (element.innerHTML !== originals.get(element)) {
        element.innerHTML = originals.get(element);
      }
    });
    root.querySelectorAll('[data-shipping-treatment-only]').forEach((element) => {
      element.hidden = !treatment;
    });
  }

  function syncAssignment() {
    let assignedTreatment = false;
    try {
      const user = window.igData?.user;
      const inScope = user?.getExperiments()?.some((experiment) => experiment.id === experimentId);
      assignedTreatment = Boolean(inScope && user.getTestGroup(experimentId)?.id === treatmentId);
    } catch (error) {
      console.warn('[Shipping test] Assignment unavailable; retaining control messaging.', error);
    }
    treatment = assignedTreatment;
    document.documentElement.dataset.shippingTestGroup = treatment ? 'treatment' : 'control';
    render();
    window.dispatchEvent(new CustomEvent('latico:shipping-group', { detail: { treatment } }));
  }

  // Handles both an already-loaded SDK and its documented asynchronous ready event.
  window.addEventListener('ig:ready', syncAssignment);
  window.addEventListener('pageshow', syncAssignment);
  document.addEventListener('shopify:section:load', syncAssignment);
  const observer = new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) render();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) observer.observe(document.body, { childList: true, subtree: true });
  });
  syncAssignment();
})();
